import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import _ from 'lodash';
import * as types from '../types';
import * as actions from '../actions';
import * as selectors from '../selectors';
import { isTemp, isRoot } from '../utils';
import { Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

const isTransient = (id: string) => (isTemp(id) || isRoot(id))

// const text = (locator: types.Locator) => `${locator.name}${isTransient(locator.id) ? '*' : '[' + locator.id + ']'}`;
const text = (locator: types.Locator) => `${locator.name}${isTransient(locator.id) ? '*' : ''}`;

const Breadcrumbs: React.FC<{}> = ({ }) => {
    const dispatch = useDispatch();
    const stack: types.StackItem[] = useSelector(selectors.SelectStack());

    const handleGoto = (index: number) => () => {
        dispatch(actions.goto(index));
    }

    const linkProps: SxProps<Theme> = {
        display: 'flex',
        alignItems: 'center',
        color: theme => theme.palette.text.primary,
        fontSize: 'normal',
        fontStyle: 'italic'
    }

    return <MUIBreadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        {
            stack.map(
                (stackItem, index) => (
                    index < stack.length - 1
                        ?
                        <Link
                            underline="hover"
                            sx={{
                                ...linkProps,
                                color: theme => theme.palette.text.secondary,
                                cursor: 'pointer',
                            }}
                            color="inherit"
                            key={index}
                            onClick={handleGoto(index)}
                        >

                            {text(stackItem.locator)}

                        </Link>
                        :
                        <Typography
                            sx={linkProps}
                            key={index}
                        >
                            {text(stackItem.locator)}
                        </Typography>
                )
            )
        }
    </MUIBreadcrumbs>

};

export default Breadcrumbs;
